import { HttpClient, HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { ApiService } from '@shared/services/api.service';
import { TokenService } from '@shared/services/token.service';
import { UtilsService } from '@shared/services/utils.service';
import { format, parse, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { paymentsListMock } from 'src/mocks/payments-fake.mock';
import { NgxExtendedPdfViewerComponent } from 'ngx-extended-pdf-viewer';
import { subMenuItems } from '../submenu';
import { AutoComplete } from 'primeng/autocomplete';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { catchError, debounceTime, distinctUntilChanged, firstValueFrom, Subject, throwError } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { PrinterService } from '@shared/services/printer.service';
import { PaymentsMenuService } from '@shared/services/payments-menu.service';


@Component({
  selector: 'app-payments-summary',
  templateUrl: './payments-summary.component.html',
  styleUrls: ['./payments-summary.component.scss'],
  providers: [MessageService],
})
export class PaymentsSummaryComponent implements OnInit {

  @ViewChild('pdfViewer') pdfViewer!: NgxExtendedPdfViewerComponent;
  @ViewChild('searcherAutocomplete') searcherAutocomplete!: AutoComplete;
  @ViewChild(Table) dt!: Table;

  public loading: boolean = false;
  public tickets!: any[];
  public dateFilter: Date | undefined;
  public officeFilter: string | null = '';
  public offices: any = [];
  public showDialog: boolean = false;
  public paymentDetail: any;
  public filteredTickets: any = [];
  public textToSearch: string = '';
  public showRefundTicket: boolean = false;
  public showCancelTicket: boolean = false;
  public showRefundTicketSee: boolean = false;
  public showRefundBookingTicket: boolean = false;
  public showCancelTicketSee: boolean = false;
  public commentRefundSee: string = '';
  public commentCancelSee: string = '';
  public commentRefund: string = '';
  public commentCancel: string = '';
  public selectedTicket: number = 0;
  public selectedTicketData: any = {};
  public user!: any;
  public userRol: string = '';
  public selectedTicketToGenerate: any = null;
  public results: any[] = [];
  public totalRecords: number = 0;
  private searchSubject = new Subject<string>();
  public currentPage: number = 0;
  public searcherCriteria: string = '';
  public formCustomer!: FormGroup;
  public formAddressCustomer!: FormGroup;
  public submitAttemptedCustomer: boolean = false;
  public selectedCustomer: any = null;
  public selectedAddress: any = null;
  public warningMessage!: string;
  public address: any = null;
  public formRefund!: FormGroup;
  public isRefundAmountLocked: boolean = false;
  public bookingSelected: any = null;
  public headerRefund: string = '';
  public isSimpleTicket: boolean = false;

  public pollingTickets: any = null;

  public responsibleRefundSee: string = '';
  public dataTicketSelected: any = [];
  public pdfSrc: string = '';
  public dropDownFilterTicket: any = [
    { name: 'Todos los tickets', id: '' },
    { name: 'Tickets devueltos', id: 2 },
    { name: 'Tickets con factura', id: 'invoice' },
  ];
  public selectedFilterTicket: any = {};
  public isConnected = false;

  public formSteps: { [key: string]: boolean } = {
    'customerDataForm': false
  }

  constructor(
    public router: Router,
    public apiService: ApiService,
    public messageService: MessageService,
    public utils: UtilsService,
    public tokenService: TokenService,
    public http: HttpClient,
    public cdr: ChangeDetectorRef,
    public formBuilder: FormBuilder,
    public printerService: PrinterService,
    private subMenuService: PaymentsMenuService
  ) { }

  public subMenuItems: Array<IToolbarItem> = [];

  async ngOnInit() {
    await this.printerService.connectToStoredDevice();
    this.printerService.printerIsConnected().subscribe(connected => {
      this.isConnected = connected;
    });

    this.subMenuItems = this.subMenuService.getSubMenuItems();

    this.apiService.getUserAuth().subscribe((response: any) => {
      this.user = response;
    });

    let userAuth = JSON.parse(localStorage.getItem('me') || '');
    this.userRol = (JSON.parse(localStorage.getItem('me') || '')).roles[0];

    this.apiService.get('/office/get').subscribe((response: any) => {
      this.offices = response;
    });

    this.formCustomer = this.formBuilder.group({
      name: ['', [Validators.required]],
      cif: [''],
      phone: [''],
      email: ['', [Validators.email]],
    });

    this.formAddressCustomer = this.formBuilder.group({
      street_name: ['', [Validators.required]],
      street_number: ['', [Validators.required]],
      floor: [''],
      description: [''],
      city: ['', [Validators.required]],
      province: [''],
      country: ['', [Validators.required]],
      postal_code: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9\\s\\-]{5,}$')]]
    });

    this.formRefund = this.formBuilder.group({
      booking_id: ['', [Validators.required]],
      status_id: [''],
      unit_price: ['', [Validators.required, Validators.pattern('^[0-9]+(\.[0-9]{1,2})?$')]],
      refund_comment: ['', [Validators.required]],
      refund_ticket: [''],
      payment_method: ['EFECTIVO'],
      is_booking_group: [false]
    });

  }

  ngAfterViewInit() {
    this.searchSubject.pipe(
      debounceTime(300),
      // distinctUntilChanged()
    ).subscribe(searchText => {
      this.filterResults(searchText);
    });
    this.loadTickets({ first: 0 });
    this.pollingTickets = setInterval(() => {
      this.loadTickets();
    }, 60000);
    this.cdr.detectChanges();
  }

  formatDateToMadrid(dateString: string) {
    if (dateString == null) return '';
    const dateToUTC = zonedTimeToUtc(dateString, 'UTC');
    const madridTime = utcToZonedTime(dateToUTC, 'Europe/Madrid');
    return format(madridTime, 'dd/MM/yyyy, HH:mm:ss');
  }

  saveCustomer() {

    if (this.formCustomer.valid) {
      this.submitAttemptedCustomer = false;
      const customerFormData = this.formCustomer.value;
      if (this.selectedCustomer) {
        if (this.isCustomerDataModified(customerFormData)) {
          this.updateCustomer(customerFormData);
        }
      } else {
        this.createCustomer(customerFormData);
      }
      this.updateTicketFields();
    }
  }

  createCustomer(customerData: any) {
    this.apiService.post('/customer/create', customerData).subscribe(
      (response: any) => {
        this.selectedCustomer = response;
        this.address = null;
      },
      (error) => {
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  updateCustomer(customerData: any) {
    this.apiService.post(`/customer/update/${this.selectedCustomer.id}`, customerData).subscribe(
      (response: any) => {
        this.selectedCustomer = { ...this.selectedCustomer, ...customerData };
      },
      (error) => {
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  isCustomerDataModified(data: any): boolean {
    return (
      data.name !== this.selectedCustomer.name ||
      data.cif !== this.selectedCustomer.cif ||
      data.phone !== this.selectedCustomer.phone ||
      data.email !== this.selectedCustomer.email
    );
  }

  handleValidationErrors(validationData: any) {
    Object.keys(validationData).forEach(key => {
      const errorMessages = validationData[key];

      const messageToast = ` ${errorMessages.join(", ")}`;
      this.messageService.add({ severity: 'error', summary: 'Error de validación', detail: messageToast, life: 30000 });
    });
  }

  async loadTickets(event?: TableLazyLoadEvent) {

    this.totalRecords = 0;
    this.loading = true;
    if (event) {
      this.currentPage = Number((event?.first === 0 || event?.first == undefined) ? 1 : event.first / (event.rows == undefined ? 1 : event.rows) + 1);
    }
    let formattedDate: any = null;
    let statusToSeach: any = null;
    if (!this.selectedFilterTicket || Object.keys(this.selectedFilterTicket).length === 0) {
      statusToSeach = null;
    } else {
      statusToSeach = this.selectedFilterTicket.id;
    }

    if (this.officeFilter && this.officeFilter.trim() == '') {
      this.officeFilter = null;
    }
    if (this.dateFilter != undefined) {
      formattedDate = format(this.dateFilter, 'yyyy-MM-dd');
    }

    let res = await this.apiService.getTicketsPaginated(this.currentPage, this.searcherCriteria, statusToSeach, formattedDate, this.officeFilter).toPromise();

    let tickets = res.data;

    this.filteredTickets = tickets;
    this.totalRecords = res.total_tickets;
    this.loading = false;

  }

  onSearchInput(event: any) {

    this.searchSubject.next(this.searcherCriteria);
  }

  isToday(dateString: string): boolean {
    const today = new Date();
    const ticketDate = new Date(dateString);


    return today.getFullYear() === ticketDate.getFullYear() &&
      today.getMonth() === ticketDate.getMonth() &&
      today.getDate() === ticketDate.getDate();
  }

  filterResults(text: string) {
    this.dt.clear();
    if (text.trim() == '') {
      this.searcherCriteria = '';
    }
    this.loadTickets();
  }

  ngOnDestroy() {
    this.searchSubject.unsubscribe();
    if (this.pollingTickets) {
      clearInterval(this.pollingTickets);
    }
  }

  validateSimpleTicket(){
    if(this.isSimpleTicket){
      return false;
    }else{
      return !this.selectedCustomer || !this.address;
    }

  }

  async exportExcel() {
    // let ticketsId = this.filteredTickets.map((ticket: any) => ticket.id);
    let formattedDate: any = null;
    let statusToSeach: any = null;
    if (!this.selectedFilterTicket || Object.keys(this.selectedFilterTicket).length === 0) {
      statusToSeach = null;
    } else {
      statusToSeach = this.selectedFilterTicket.id;
    }

    if (this.officeFilter && this.officeFilter.trim() == '') {
      this.officeFilter = null;
    }
    if (this.dateFilter != undefined) {
      formattedDate = format(this.dateFilter, 'yyyy-MM-dd');
    }

    let ticketsId = await firstValueFrom(this.apiService.getTicketIdsFromFilters(this.searcherCriteria, statusToSeach, formattedDate, this.officeFilter));

    if (!ticketsId) {
      ticketsId = [];
    }
    let ticketsIdString = ticketsId.join(',');

    window.open(`${environment.baseUrlWeb}/tickets/export/excel?token=${this.tokenService.getToken()}&tickets=${ticketsIdString}`);
  }

  public formatDate(date: Date): string {
    return format(date, 'dd-MM-yyyy');
  }

  public formatHour(date: Date): string {
    return format(date, 'HH:mm');
  }

  printTicket($event: any, ticket_id: number) {
    this.pdfSrc = `${environment.baseUrlWeb}/ticket/imprimir/${ticket_id}?print_type=print&token=${this.tokenService.getToken()}`;

    this.http.get(this.pdfSrc).subscribe(response => {
      const ticket = response as string[];
      this.printerService.printFullTicket(ticket);

    }, error => {
      console.error('Error al cargar el PDF:', error);
    });

  }

  seeTicket($event: any, ticket_id: number) {
    this.pdfSrc = `${environment.baseUrlWeb}/ticket/imprimir/${ticket_id}?print_type=pdf&token=${this.tokenService.getToken()}`;

    this.http.get(this.pdfSrc, { responseType: 'blob' }).subscribe(blob => {

      const blobUrl = URL.createObjectURL(blob);

      let iframe: HTMLIFrameElement = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      };

    }, error => {
      console.error('Error al cargar el PDF:', error);
    });
  }

  searchCustomer(event: any) {
    const query = event.query;
    if (query && query.length > 2) {
      this.apiService.getCustomersPaginated(query).subscribe((response: any) => {
        this.results = response;
      });
    } else {
      this.results = [];
    }
  }

  resetCustomer() {
    this.selectedCustomer = null;
    if (this.searcherAutocomplete.inputEL) {
      this.searcherAutocomplete.inputEL.nativeElement.value = '';
    }
    this.address = null;
    this.formCustomer.patchValue({
      name: '',
      cif: '',
      phone: '',
      email: ''
    });
  }

  onSelectCustomer(event: any) {
    this.selectedCustomer = event.value;
    this.formCustomer.patchValue({
      name: this.selectedCustomer.name,
      cif: this.selectedCustomer.cif,
      phone: this.selectedCustomer.phone,
      email: this.selectedCustomer.email
    });
    this.address = this.selectedCustomer.address;
  }

  saveAddressCustomer() {
    const addressNewData = this.formAddressCustomer.value;
    if (this.formCustomer.valid && this.formAddressCustomer) {
      if (this.selectedAddress) {
        const addressSearched = this.address;
        if (addressSearched) {
          this.updateAddress(this.selectedAddress);
        }
      } else {
        if (!this.selectedCustomer) {
          const customerFormData = this.formCustomer.value;
          this.createCustomer(customerFormData);
        }
        this.createAddress(addressNewData);
      }
    }
    if (this.isFormValid(this.formAddressCustomer)) {
      this.formAddressCustomer.reset();
      this.toggleForm('addressCustomerForm');
    }
  }

  updateAddress(customerAddressData: any) {
    const addressId = customerAddressData.id;
    this.apiService.post(`/address/update/${addressId}`, this.formAddressCustomer.value).subscribe(
      (response: any) => {
        this.address = response.address;
        this.selectedAddress = response.address;

      },
      (error) => {
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  createAddress(customerAddressData: any) {
    this.apiService.post(`/address/create/${this.selectedCustomer.id}`, customerAddressData).subscribe(
      (response: any) => {
        this.address = response.address;

      },
      (error) => {
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  editAddress(address: any) {
    this.selectedAddress = address;
    this.formAddressCustomer.patchValue(address);
    this.toggleForm('addressCustomerForm');
  }

  getMaxRefundAmount() {
    let totalPaid = this.selectedTicketData?.total || 0;
    return totalPaid;
  }

  deleteAddress(address: any) {
    if (this.selectedCustomer) {
      const addressToDelete = this.address;
      if (addressToDelete) {
        this.apiService.post(`/address/delete/${address.id}`, address).subscribe(
          (response: any) => {

          },
          (error) => {
            if (error && error.error && error.error.data) {
              this.handleValidationErrors(error.error.data);
            }
          }
        );
        this.address = null;
        this.selectedAddress = null;
      }
    }
  }

  isFormValid(form: FormGroup): boolean {
    return form.valid;
  }

  toggleForm(section: string) {
    this.formSteps[section] = !this.formSteps[section];
  }

  ticketReturn($event: any, ticket: any) {
    let hasBooking = ticket.details.some((detail: any) => detail.booking);
    if (!hasBooking) {
      this.selectedTicket = ticket.id;
      this.showRefundTicket = true;
    }else{
      const booking = ticket.details.find((detail: any) => detail.booking).booking;
      if (booking) {
        this.bookingSelected = booking;
      }
      this.selectedTicket = ticket.id;
      this.selectedTicketData = ticket;
      let totalImport: number = ticket.details.reduce((total: number, detail: any) => {
        return total + (detail.units * detail.unit_price);
      }, 0);
      this.formRefund.get('unit_price')?.setValue(totalImport);
      this.formRefund.get('refund_comment')?.setValue('');
      this.formRefund.get('refund_ticket')?.setValue(ticket.id);
      this.formRefund.get('booking_id')?.setValue(booking.id);
      this.formRefund.get('payment_method')?.setValue('EFECTIVO');
      let isBookingGroup = booking.services[0].service_profile.service.is_group;
      this.formRefund.get('is_booking_group')?.setValue(isBookingGroup);
      this.headerRefund = `Devolución de €${totalImport.toFixed(2)}`;
      this.isRefundAmountLocked = true;
      this.showRefundBookingTicket = true;

    }

  }

  showGenerateInvoiceModal(selectedTicket: any) {
    this.selectedTicketToGenerate = selectedTicket;
    this.selectedCustomer = null;

    let ticket = this.filteredTickets.find((ticketToFind: any) => {
      return ticketToFind.id == selectedTicket.id
    });
    if (ticket.customer_id) {
      this.generateInvoiceFromTicket();
    } else {
      this.toggleForm('customerDataForm');
    }
  }

  showAttachClientModal(selectedTicket: any) {
    this.selectedTicketToGenerate = selectedTicket;
    let hasBooking = selectedTicket.details.some((detail: any) => detail.booking != null);
    let hasInvoice = (selectedTicket.invoices?.length > 0)? true : false;
    if(!hasBooking && !hasInvoice){
      this.isSimpleTicket = true;
    }else{
      this.isSimpleTicket = false;
    }

    this.selectedCustomer = null;

    let ticket = this.filteredTickets.find((ticketToFind: any) => {
      return ticketToFind.id == selectedTicket.id
    });

    if (ticket.customer_id && ticket.customer?.address) {
      this.seeTicket(null, ticket.id);
    } else {
      this.toggleForm('customerDataForm');
    }
  }

  generateInvoiceFromTicket() {
    let ticket = this.selectedTicketToGenerate;
    if (this.selectedCustomer?.id) {
      const ticketData = {
        customer_id: this.selectedCustomer.id
      };
      setTimeout(() => {
        this.filteredTickets = this.filteredTickets.map((ticketToSearch: any) => {
          if (this.selectedTicketToGenerate.id === ticketToSearch.id) {
            return { ...ticketToSearch, customer_id: this.selectedCustomer.id };
          }
          return ticketToSearch;
        });
      }, 0);
      this.cdr.detectChanges();
      this.apiService.updateFieldsTicket(ticket.id, ticketData).subscribe((response: any) => {
        this.selectedCustomer = null;
        if (this.searcherAutocomplete.inputEL) {
          this.searcherAutocomplete.inputEL.nativeElement.value = '';
        }
        this.formSteps['customerDataForm'] = !this.formSteps['customerDataForm'];
        const params = new HttpParams().set('details', JSON.stringify(ticket.details));
        window.open(`${environment.baseUrlWeb}/invoices/ticket/generate/${ticket.id}?${params.toString()}&token=${this.tokenService.getToken()}`, '_blank');
      });
    }
  }

  updateTicketFields() {
    let ticket = this.selectedTicketToGenerate;
    if (this.selectedCustomer?.id) {
      const ticketData = {
        customer_id: this.selectedCustomer.id
      };
      setTimeout(() => {
        this.filteredTickets = this.filteredTickets.map((ticketToSearch: any) => {
          if (this.selectedTicketToGenerate.id === ticketToSearch.id) {
            return { ...ticketToSearch, customer_id: this.selectedCustomer.id };
          }
          return ticketToSearch;
        });
      }, 0);
      this.cdr.detectChanges();
      this.apiService.updateFieldsTicket(ticket.id, ticketData).subscribe((response: any) => {
        this.selectedCustomer = null;
        if (this.searcherAutocomplete.inputEL) {
          this.searcherAutocomplete.inputEL.nativeElement.value = '';
        }
        this.formSteps['customerDataForm'] = !this.formSteps['customerDataForm'];

        this.seeTicket(null, ticket.id);
      });
    }
  }

  ticketCancel($event: any, ticket_id: number) {
    this.selectedTicket = ticket_id;
    this.showCancelTicket = true;
  }

  ticketReturnSee($event: any, ticket_id: number) {
    this.selectedTicket = ticket_id;
    this.dataTicketSelected = this.filteredTickets.find(
      (ticketAux: any) => ticketAux.id == ticket_id
    );
    if (this.dataTicketSelected) {
      this.commentRefundSee = this.dataTicketSelected.refund_comment;
      this.responsibleRefundSee = `${this.dataTicketSelected.refund_user?.name} (${this.dataTicketSelected.refund_user?.employee_code})`;
    }
    this.showRefundTicketSee = true;
  }

  sendTicketRefund($event: any) {
    if (confirm(`¿Seguro desea marcar este ticket como "devolución"?`)) {
      let today = new Date().toISOString().slice(0, 19).replace('T', ' ');

      this.apiService
        .post('/tickets/update-fields/' + this.selectedTicket, {
          status: 2,
          refund_comment: this.commentRefund,
          refund_user_id: this.user.id,
          refund_datetime: today,
        })
        .subscribe((response: any) => {

          const index = this.filteredTickets.findIndex(
            (item: any) => item.id === this.selectedTicket
          );
          if (index !== -1) {
            this.filteredTickets[index].status = 2;
          }
          this.apiService
            .post('/tickets/refund-ticket/' + response.id, {})
            .subscribe((response: any) => { });

          this.filterResults(this.searcherCriteria);
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Estado de ticket modificado correctamente',
          });
          this.showRefundTicket = false;

        });
    }
  }

  sendBookingTicketRefund() {
    if (this.formRefund.valid) {
      this.filteredTickets = this.filteredTickets.map((ticket: any) => {
        if (ticket.id == this.selectedTicket) {
            ticket['status'] = 2;
            ticket['refund_comment'] = this.formRefund.value.refund_comment;
            ticket['refund_user'] = this.user;
            ticket['refund_user_id'] = this.user.id;
            let today = new Date().toISOString().slice(0, 19).replace('T', ' ');
            ticket['refund_datetime'] = today;
        }
        return ticket;
      });
      this.apiService.post('/tickets/refund-total-ticket/booking', this.formRefund.value)
        .pipe(
          catchError((error) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se guardo correctamente la devolución, hubo un error.',
            });
            return throwError(() => new Error('Something bad happened; please try again later.'));
          })
        ).subscribe((response: any) => {
          this.showRefundBookingTicket = false;
          this.formRefund.reset();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Devolución guardada correctamente',
          });
        });
    }
  }

  sendTicketCancel($event: any) {
    if (confirm(`¿Seguro desea marcar este ticket como "cancelado"?`)) {
      let today = new Date().toISOString().slice(0, 19).replace('T', ' ');

      this.apiService
        .post('/tickets/update-fields/' + this.selectedTicket, {
          status: 4,
          cancel_comment: this.commentCancel,
          cancel_user_id: this.user.id,
          cancel_datetime: today,
        })
        .subscribe((response: any) => {
          const index = this.tickets.findIndex(
            (item) => item.id === this.selectedTicket
          );
          if (index !== -1) {
            this.tickets[index].status = 4;
          }


          this.filterResults(this.searcherCriteria);
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Estado de ticket cancelado correctamente',
          });
          this.showCancelTicket = false;
        });
    }
  }

  cancelTicketInvoice($event: any, ticketId: number, i: number) {
    this.apiService
      .updateFieldsTicket(ticketId, { cancelAndCreateTicket: true })
      .subscribe((response: any) => {
        this.filteredTickets[i].invoice_generation =
          response.invoice_generation;
        this.filteredTickets[i].invoice_number = response.invoice_number;
        this.filteredTickets[i].same_quarter = true;
        this.tickets = this.tickets.map((ticket: any) => {
          if (ticket.id == ticketId) {
            ticket['invoice_generation'] = response.invoice_generation;
            ticket['invoice_number'] = response.invoice_number;
            ticket['same_quarter'] = true;
          }
          return ticket;
        });
        this.messageService.add({
          severity: 'success',
          summary: 'Éxito',
          detail: 'Factura cancelada y se ha creado una nueva',
        });
      });
  }



}
